import React, { useContext } from 'react'
import { useRouter } from 'next/router'

import { H2 } from '@jarvis.oddle/core/components/Typo'
import Modal, { CloseButton } from '@jarvis.oddle/core/components/Modal'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import { colorConstants } from '@jarvis.oddle/core/theme/default'

import LanguageSelectionRadio from './LanguageSelectionRadio'
import LanguageModalForm from './LanguageModalForm'
import useAppSelector from 'src/hooks/useAppSelector'
import { selectDetailMenuSite } from 'src/redux/meta'
import { makeControlledModal } from 'src/decorators/ModalController'

const LanguageSelectionModal = ({
  modal
}: {
  modal: {
    show: boolean
    onClose: (handler?) => void
    onClosed: () => void
  }
}) => {
  const { t } = useContext(TranslationContext)
  const router = useRouter()
  const locales = useAppSelector(selectDetailMenuSite)?.locales

  return (
    <Modal {...modal} withoutFocusTrap slideInAnimation='bottom'>
      <LanguageModalForm
        modal={modal}
        width='100%'
        buttonText={t('Apply')}
        Header={
          <Modal.Header>
            <H2 bold>{t('Change Language')}</H2>
            <CloseButton fill={colorConstants.black} onClick={modal.onClose} />
          </Modal.Header>
        }
        Body={
          <LanguageSelectionRadio locale={router.query.locale as string} locales={locales} />
        }
      />
    </Modal>
  )
}

export default makeControlledModal(
  LanguageSelectionModal,
  'LanguageSelectionModal'
)
